<template>
  <div class="tender-entity">
    <!-- 搜索框和视图切换 -->
    <div class="search-box">
      <!-- 合同查询按钮 -->
      <el-button type="primary" @click="showTenderDialog = true,visiableshow=false" style="margin-right: 10px;">
        <el-icon style="margin-right: 4px;">
          <Document />
        </el-icon>
        合同选择
        <el-badge v-if="selectedTenderList.length > 0" :value="selectedTenderList.length" 
          class="tender-badge" />
      </el-button>

      <el-input v-model="searchKeyword" placeholder="请输入产品名称、物料号、型号搜索" clearable
       @clear="handleSearch"
       style="width: 300px; margin-right: 10px;">

         <!-- @keyup.enter="handleSearch" -->
      <!-- <el-button type="primary" @click="confirmTenderSelection(false)">确定查询</el-button> -->

        <template #prefix>
          <el-icon>
            <Search />
          </el-icon>
        </template>
      </el-input>
      <el-button type="primary" @click="refreshData">查询</el-button>

      <el-radio-group v-model="viewMode" style="margin-left: 10px;">
        <!-- <el-radio-button label="table">
          <el-icon style="margin-right: 4px;">
            <List />
          </el-icon>
          表格
        </el-radio-button> -->
        <el-radio-button label="tree">
          <el-icon style="margin-right: 4px;">
            <Share />
          </el-icon>
          树状图
        </el-radio-button>
        <el-radio-button label="grid">
          <el-icon style="margin-right: 4px;">
            <Grid />
          </el-icon>
          网格
        </el-radio-button>
        <el-radio-button label="list">
          <el-icon style="margin-right: 4px;">
            <Menu />
          </el-icon>
          列表
        </el-radio-button>
      </el-radio-group>
      <el-button type="primary" style="margin-left: 10px;">
        <a style="text-decoration: none;color: #fff;" 
        target="_blank"
         href="https://static-mp-b580fc3c-bfde-49da-964d-6aa189793e41.next.bspapp.com/#/subpkg/Tender/Cozehref/Cozehref?type=1">招投标合同数据录入</a></el-button>
      <el-button type="primary" @click="showTenderDialog = true,visiableshow=true,visiabletype=2">合同可见性配置</el-button>


    </div>
    

    <!-- 表格视图 -->
    <div v-if="viewMode === '1'" class="table-container">
      <el-table ref="tableRef" :data="tableData" v-loading="loading" style="width: 100%; margin-top: 20px;" border
        stripe :header-cell-style="{ background: '#f5f7fa', color: '#606266', fontWeight: '600' }"
        :cell-style="{ padding: '12px 0' }" height="600" @header-click="handleHeaderClick">
        <template v-if="isContractQuery">
          <el-table-column min-width="200" resizable align="center">
            <template #header>
              <span class="table-header-with-icon">
                <el-icon><Document /></el-icon>
                合同名
              </span>
            </template>
            <template #default="{ row }">
              <div class="contract-name-cell">{{ getContractName(row) }}</div>
            </template>
          </el-table-column>
       
          <el-table-column min-width="140" resizable align="center">
            <template #header>
              <span class="table-header-with-icon">
                <el-icon><Files /></el-icon>
                总重量KG
              </span>
            </template>
            <template #default="{ row }">
              {{ getContractWeightDisplay(row) || '--' }}
            </template>
          </el-table-column>
             <el-table-column min-width="140" resizable align="center">
            <template #header>
              <span class="table-header-with-icon">
                <el-icon><Money /></el-icon>
                总价格
              </span>
            </template>
            <template #default="{ row }">
              {{ getContractPriceDisplay(row) || '--' }}
            </template>
          </el-table-column>
          <el-table-column min-width="500" resizable align="center">
            <template #header>
              <span class="table-header-with-icon">
                <el-icon><Files /></el-icon>
                详情条例
              </span>
            </template>
            <template #default="{ row }">
              <div v-if="getContractDetailList(row).length" class="detail-column">
                <div class="detail-item" v-for="(detail, idx) in getContractDetailList(row)" :key="idx">
                  <div class="detail-index">
                    {{ idx + 1 }}
                  </div>
                  <div class="detail-info">
                    <div class="detail-info-row">
                      <span class="detail-label">
                        <el-icon class="detail-icon"><Goods /></el-icon>
                        产品:
                      </span>
                      <span class="detail-value">{{ formatDetailField(detail.brand) }}</span>
                      <span class="detail-label">
                        <el-icon class="detail-icon"><Setting /></el-icon>
                        型号:
                      </span>
                      <span class="detail-value">{{ formatDetailField(detail.model) }}</span>
                    </div>
                    <div class="detail-info-row">
                      <span class="detail-label">
                        <el-icon class="detail-icon"><Connection /></el-icon>
                        重量:
                      </span>
                      <span class="detail-value">{{ formatDetailWeight(detail.weight) }}</span>
                      <span class="detail-label">
                        <el-icon class="detail-icon"><Files /></el-icon>
                        物料号:
                      </span>
                      <span class="detail-value">{{ formatDetailField(detail.materialNumber) }}</span>
                    </div>
                    <div class="detail-info-row">
                      <span class="detail-label">
                        <el-icon class="detail-icon"><Shop /></el-icon>
                        制造商:
                      </span>
                      <span class="detail-value">{{ formatDetailField(detail.manufacturer) }}</span>
                    </div>
                    <div class="detail-info-row detail-material-row">
                      <span class="detail-label">
                        <el-icon class="detail-icon"><Connection /></el-icon>
                        材料明细:
                      </span>
                      <div class="detail-material-value">
                        <div class="material-detail-wrapper">
                          <!-- 材料列表 (virtual == 0) -->
                          <div v-if="getDetailMaterialList(detail).length > 0 || getDetailPlainItems(detail).length > 0" class="detail-material-section">
                            <div class="detail-material-title">材料列表 ({{ getDetailMaterialList(detail).length + getDetailPlainItems(detail).length }} 项)</div>
                            <div
                              v-for="(item, index) in getDetailMaterialList(detail)"
                              :key="`material-${index}`"
                              class="material-detail-item"
                            >
                              <div
                                v-if="typeof item === 'object' && item !== null"
                                class="material-detail-card"
                              >
                                <div class="material-field">
                                  <span class="material-label">
                                    <el-icon class="material-icon"><Star /></el-icon>
                                    材料名{{ index + 1 }}
                                  </span>
                                  <span class="material-value">
                                    {{ item.nameElement || '--' }}
                                  </span>
                                </div>
                                <div class="material-field">
                                  <span class="material-label">
                                    <el-icon class="material-icon"><Scale /></el-icon>
                                    总重量(KG)
                                  </span>
                                  <span class="material-value">
                                    {{ item.heaveyAll != null ? formatFieldValue('heaveyAll', item.heaveyAll) : (item.quantityAll ?? item.quantity ?? '--') }}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div v-for="(item, index) in getDetailPlainItems(detail)" :key="`plain-${index}`" class="material-plain-text">
                              {{ item }}
                            </div>
                          </div>
                          <!-- 虚拟列表 (virtual == 1) -->
                          <div v-if="getDetailVirtualList(detail).length > 0" class="detail-material-section">
                            <div class="detail-material-title">虚拟列表 ({{ getDetailVirtualList(detail).length }} 项)</div>
                            <div
                              v-for="(item, index) in getDetailVirtualList(detail)"
                              :key="`virtual-${index}`"
                              class="material-detail-item"
                            >
                              <div
                                v-if="typeof item === 'object' && item !== null"
                                class="material-detail-card"
                              >
                                <div class="material-field">
                                  <span class="material-label">
                                    <el-icon class="material-icon"><Star /></el-icon>
                                    材料名{{ index + 1 }}
                                  </span>
                                  <span class="material-value">
                                    {{ item.nameElement || '--' }}
                                  </span>
                                </div>
                                <div class="material-field">
                                  <span class="material-label">
                                    <el-icon class="material-icon"><Scale /></el-icon>
                                    总重量(KG)
                                  </span>
                                  <span class="material-value">
                                    {{ item.heaveyAll != null ? formatFieldValue('heaveyAll', item.heaveyAll) : (item.quantityAll ?? item.quantity ?? '--') }}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <span v-else>--</span>
            </template>
          </el-table-column>
        </template>
        <template v-else>
          <el-table-column prop="name" min-width="200" resizable align="center">
            <template #header>
              <span class="table-header-with-icon">
                <el-icon><Document /></el-icon>
                合同名
              </span>
            </template>
            <template #default="{ row }">
              <div class="contract-name-cell">{{ row.name }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="brand" min-width="120" resizable show-overflow-tooltip align="center">
            <template #header>
              <span class="table-header-with-icon">
                <el-icon><Goods /></el-icon>
                产品名
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="model" min-width="120" resizable show-overflow-tooltip align="center">
            <template #header>
              <span class="table-header-with-icon">
                <el-icon><Setting /></el-icon>
                型号
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="weight" min-width="100" resizable align="center">
            <template #header>
              <span class="table-header-with-icon">
                <el-icon><Goods /></el-icon>
                重量KG
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="materialNumber" min-width="120" resizable show-overflow-tooltip align="center">
            <template #header>
              <span class="table-header-with-icon">
                <el-icon><Files /></el-icon>
                物料号
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="manufacturer" min-width="120" resizable show-overflow-tooltip align="center">
            <template #header>
              <span class="table-header-with-icon">
                <el-icon><Shop /></el-icon>
                制造商
              </span>
            </template>
          </el-table-column>

        </template>

        <el-table-column min-width="400" resizable align="center">
          <template #header>
            <span class="table-header-with-icon">
              <el-icon><Connection /></el-icon>
              材料总汇列表
            </span>
          </template>
          <template #default="scope">
            <div v-if="scope.row.list && scope.row.list.length > 0" class="material-summary-table-wrapper">
              <el-collapse>
                <!-- 材料列表 (virtual == 0) -->
                <el-collapse-item v-if="getMaterialList(scope.row).length > 0 || getPlainItems(scope.row.list).length > 0" :title="`材料列表 (${getMaterialList(scope.row).length + getPlainItems(scope.row.list).length} 项)`" :name="`material-${scope.$index}`">
                  <el-table
                    :data="getMaterialList(scope.row)"
                    size="small"
                    border
                    stripe
                    :show-header="true"
                    style="width: 100%"
                    :header-cell-style="{ background: '#f5f7fa', color: '#606266', fontWeight: '600', textAlign: 'center' }"
                    :cell-style="{ textAlign: 'center', padding: '8px 4px' }"
                  >
                    <el-table-column prop="nameElement" label="材料名" min-width="120" align="center" show-overflow-tooltip>
                      <template #default="{ row }">
                        {{ row.nameElement || '--' }}
                      </template>
                    </el-table-column>
                   
                    <el-table-column prop="heaveyAll" label="总重量(KG)" min-width="120" align="center">
                      <template #default="{ row }">
                        {{ row.heaveyAll != null ? formatFieldValue('heaveyAll', row.heaveyAll) : (row.quantityAll ?? row.quantity ?? '--') }}
                      </template>
                    </el-table-column>
                     <el-table-column prop="moneyALL" label="总价格" min-width="120" align="center">
                      <template #default="{ row }">
                        {{ row.moneyALL != null ? formatFieldValue('moneyALL', row.moneyALL) : '--' }}
                      </template>
                    </el-table-column>
                  </el-table>
                  <div v-if="getPlainItems(scope.row.list).length > 0" class="material-plain-items">
                    <div v-for="(item, index) in getPlainItems(scope.row.list)" :key="index" class="material-plain-text">
                      {{ item }}
                    </div>
                  </div>
                </el-collapse-item>
                <!-- 虚拟列表 (virtual == 1) -->
                <el-collapse-item v-if="getVirtualList(scope.row).length > 0" :title="`虚拟列表 (${getVirtualList(scope.row).length} 项)`" :name="`virtual-${scope.$index}`">
                  <el-table
                    :data="getVirtualList(scope.row)"
                    size="small"
                    border
                    stripe
                    :show-header="true"
                    style="width: 100%"
                    :header-cell-style="{ background: '#f5f7fa', color: '#606266', fontWeight: '600', textAlign: 'center' }"
                    :cell-style="{ textAlign: 'center', padding: '8px 4px' }"
                  >
                    <el-table-column prop="nameElement" label="材料名" min-width="120" align="center" show-overflow-tooltip>
                      <template #default="{ row }">
                        {{ row.nameElement || '--' }}
                      </template>
                    </el-table-column>
                   
                    <el-table-column prop="heaveyAll" label="总重量(KG)" min-width="120" align="center">
                      <template #default="{ row }">
                        {{ row.heaveyAll != null ? formatFieldValue('heaveyAll', row.heaveyAll) : (row.quantityAll ?? row.quantity ?? '--') }}
                      </template>
                    </el-table-column>
                     <el-table-column prop="moneyALL" label="总价格" min-width="120" align="center">
                      <template #default="{ row }">
                        {{ row.moneyALL != null ? formatFieldValue('moneyALL', row.moneyALL) : '--' }}
                      </template>
                    </el-table-column>
                  </el-table>
                </el-collapse-item>
              </el-collapse>
            </div>
            <span v-else style="color: #909399;">暂无数据</span>
          </template>
        </el-table-column>
        <el-table-column width="140" align="center" fixed="right">
          <template #header>
            <span class="table-header-with-icon">
              <el-icon><Picture /></el-icon>
              图片列表
            </span>
          </template>
          <template #default="scope">
            <el-button type="primary" size="small"
              :disabled="!scope.row.imgListbyidlist || scope.row.imgListbyidlist.length === 0"
              @click="showImageList(scope.row)">
              查看图片 ({{ scope.row.imgListbyidlist ? scope.row.imgListbyidlist.length : 0 }})
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 树状图视图 -->
    <div v-if="viewMode === 'tree'" class="tree-view-container" v-loading="loading">
      <el-tree :data="treeData" :props="treeProps" default-expand-all :expand-on-click-node="false" node-key="id">
        <template #default="{ node, data }">
          <div class="tree-node-content">
            <span class="tree-node-label">{{ node.label }}</span>
            <div class="tree-node-actions" v-if="data.type === 'item'">
              <el-button type="primary" size="small"
                :disabled="!data.imgListbyidlist || data.imgListbyidlist.length === 0"
                @click.stop="showImageList(data)">
                查看图片 ({{ data.imgListbyidlist ? data.imgListbyidlist.length : 0 }})
              </el-button>
            </div>
          </div>
        </template>
      </el-tree>
      <div v-if="treeData.length === 0" class="empty-tree">
        <el-empty description="暂无数据" />
      </div>
    </div>

    <!-- 网格视图 -->
    <div v-if="viewMode === 'grid'" class="grid-view-container" v-loading="loading">
      <el-row :gutter="16">
        <el-col v-for="(row, index) in tableData" :key="index" :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
          <div class="grid-item">
            <div class="grid-header">
              <h4 class="grid-title">{{ getContractName(row) }}</h4>
            </div>
             <div class="grid-info" v-if="getContractWeightDisplay(row)">
                <el-icon class="grid-icon">
                  <Shop />
                </el-icon>
                <span>{{ isContractQuery ? '总重量(KG)' : '重量' }}: {{ getContractWeightDisplay(row) }}</span>
              </div>
              
              <!-- moneyAlls -->
            <div class="grid-body">
              <div class="grid-info" v-if="getContractPriceDisplay(row)">
                <el-icon class="grid-icon">
                  <Coin />
                </el-icon>
                <span>{{ isContractQuery ? '总价格' : '价格' }}: {{ getContractPriceDisplay(row) }}</span>
              </div>
             
              <div class="grid-info" v-if="row.brand">
                <el-icon class="grid-icon">
                  <Box />
                </el-icon>
                <span>{{ row.brand }}</span>
              </div>
              <div class="grid-info" v-if="row.model">
                <el-icon class="grid-icon">
                  <Setting />
                </el-icon>
                <span>{{ row.model }}</span>
              </div>
              <div class="grid-info" v-if="row.materialNumber">
                <el-icon class="grid-icon">
                  <Document />
                </el-icon>
                <span>物料号: {{ row.materialNumber }}</span>
              </div>
              <div class="grid-info" v-if="row.manufacturer">
                <el-icon class="grid-icon">
                  <Shop />
                </el-icon>
                <span>{{ row.manufacturer }}</span>
              </div>
              <!-- 材料列表展开 -->
              <div v-if="!isContractQuery && row.list && row.list.length > 0" class="grid-material-section">
                <el-collapse>
                  <!-- 材料列表 (virtual == 0) -->
                  <el-collapse-item v-if="getMaterialList(row).length > 0 || getPlainItems(row.list).length > 0" :title="`材料列表 (${getMaterialList(row).length + getPlainItems(row.list).length} 项)`" :name="`grid-material-${index}`">
                    <div class="grid-material-table-wrapper">
                      <el-table
                        :data="getMaterialList(row)"
                        size="small"
                        border
                        stripe
                        :show-header="true"
                        style="width: 100%"
                        :header-cell-style="{ background: '#f5f7fa', color: '#606266', fontWeight: '600', textAlign: 'center' }"
                        :cell-style="{ textAlign: 'center', padding: '8px 4px' }"
                      >
                        <el-table-column prop="nameElement" label="材料名" min-width="100" align="center" show-overflow-tooltip>
                          <template #default="{ row: item }">
                            {{ item.nameElement || '--' }}
                          </template>
                        </el-table-column>
                   
                        <el-table-column prop="heaveyAll" label="总重量(KG)" min-width="100" align="center">
                          <template #default="{ row: item }">
                            {{ item.heaveyAll != null ? formatFieldValue('heaveyAll', item.heaveyAll) : (item.quantityAll ?? item.quantity ?? '--') }}
                          </template>
                        </el-table-column>
                             <el-table-column prop="moneyALL" label="总价格" min-width="100" align="center">
                          <template #default="{ row: item }">
                            {{ item.moneyALL != null ? formatFieldValue('moneyALL', item.moneyALL) : '--' }}
                          </template>
                        </el-table-column>
                      </el-table>
                      <div v-if="getPlainItems(row.list).length > 0" class="grid-material-plain-items">
                        <div v-for="(item, itemIndex) in getPlainItems(row.list)" :key="itemIndex" class="grid-material-text">
                          {{ item }}
                        </div>
                      </div>
                    </div>
                  </el-collapse-item>
                  <!-- 虚拟列表 (virtual == 1) -->
                  <el-collapse-item v-if="getVirtualList(row).length > 0" :title="`虚拟列表 (${getVirtualList(row).length} 项)`" :name="`grid-virtual-${index}`">
                    <div class="grid-material-table-wrapper">
                      <el-table
                        :data="getVirtualList(row)"
                        size="small"
                        border
                        stripe
                        :show-header="true"
                        style="width: 100%"
                        :header-cell-style="{ background: '#f5f7fa', color: '#606266', fontWeight: '600', textAlign: 'center' }"
                        :cell-style="{ textAlign: 'center', padding: '8px 4px' }"
                      >
                        <el-table-column prop="nameElement" label="材料名" min-width="100" align="center" show-overflow-tooltip>
                          <template #default="{ row: item }">
                            {{ item.nameElement || '--' }}
                          </template>
                        </el-table-column>
                   
                        <el-table-column prop="heaveyAll" label="总重量(KG)" min-width="100" align="center">
                          <template #default="{ row: item }">
                            {{ item.heaveyAll != null ? formatFieldValue('heaveyAll', item.heaveyAll) : (item.quantityAll ?? item.quantity ?? '--') }}
                          </template>
                        </el-table-column>
                             <el-table-column prop="moneyALL" label="总价格" min-width="100" align="center">
                          <template #default="{ row: item }">
                            {{ item.moneyALL != null ? formatFieldValue('moneyALL', item.moneyALL) : '--' }}
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
              
              <!-- 合同查询模式下的详情条例展开 -->
              <div v-if="isContractQuery && getContractDetailList(row).length > 0" class="grid-detail-section">
                <el-collapse>
                  <el-collapse-item :title="`详情条例 (${getContractDetailList(row).length} 项)`" :name="`detail-${index}`">
                    <div v-for="(detail, detailIdx) in getContractDetailList(row)" :key="detailIdx" class="grid-detail-item">
                      <div class="grid-detail-header">
                        <span class="grid-detail-index">{{ detailIdx + 1 }}.</span>
                        <div class="grid-detail-info">
                          <div class="grid-detail-row" v-if="detail.brand">
                            <span class="grid-detail-label">产品:</span>
                            <span class="grid-detail-value">{{ formatDetailField(detail.brand) }}</span>
                          </div>
                          <div class="grid-detail-row" v-if="detail.model">
                            <span class="grid-detail-label">型号:</span>
                            <span class="grid-detail-value">{{ formatDetailField(detail.model) }}</span>
                          </div>
                          <div class="grid-detail-row" v-if="detail.weight">
                            <span class="grid-detail-label">重量:</span>
                            <span class="grid-detail-value">{{ formatDetailWeight(detail.weight) }}</span>
                          </div>
                          <div class="grid-detail-row" v-if="detail.materialNumber">
                            <span class="grid-detail-label">物料号:</span>
                            <span class="grid-detail-value">{{ formatDetailField(detail.materialNumber) }}</span>
                          </div>
                          <div class="grid-detail-row" v-if="detail.manufacturer">
                            <span class="grid-detail-label">制造商:</span>
                            <span class="grid-detail-value">{{ formatDetailField(detail.manufacturer) }}</span>
                          </div>
                        </div>
                      </div>
                      <!-- 材料明细 -->
                      <div v-if="getDetailMaterialList(detail).length > 0 || getDetailVirtualList(detail).length > 0 || getDetailPlainItems(detail).length > 0" class="grid-detail-materials">
                        <!-- 材料列表 (virtual == 0) -->
                        <div v-if="getDetailMaterialList(detail).length > 0 || getDetailPlainItems(detail).length > 0" class="grid-detail-material-group">
                          <div class="grid-detail-material-group-title">材料列表 ({{ getDetailMaterialList(detail).length + getDetailPlainItems(detail).length }} 项)</div>
                          <div v-for="(item, itemIdx) in getDetailMaterialList(detail)" :key="`material-${itemIdx}`" class="grid-detail-material-card">
                            <div v-if="typeof item === 'object' && item !== null" class="grid-material-content">
                              <div class="grid-material-row" v-if="item.nameElement">
                                <span class="grid-material-label">材料名{{ itemIdx + 1 }}:</span>
                                <span class="grid-material-value">{{ item.nameElement }}</span>
                              </div>
                              <div class="grid-material-row" v-if="item.heaveyAll != null || item.quantityAll || item.quantity">
                                <span class="grid-material-label">总重量(KG):</span>
                                <span class="grid-material-value">
                                  {{ item.heaveyAll != null ? formatFieldValue('heaveyAll', item.heaveyAll) : (item.quantityAll ?? item.quantity ?? '--') }}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div v-for="(item, itemIdx) in getDetailPlainItems(detail)" :key="`plain-${itemIdx}`" class="grid-material-text">
                            {{ item }}
                          </div>
                        </div>
                        <!-- 虚拟列表 (virtual == 1) -->
                        <div v-if="getDetailVirtualList(detail).length > 0" class="grid-detail-material-group">
                          <div class="grid-detail-material-group-title">虚拟列表 ({{ getDetailVirtualList(detail).length }} 项)</div>
                          <div v-for="(item, itemIdx) in getDetailVirtualList(detail)" :key="`virtual-${itemIdx}`" class="grid-detail-material-card">
                            <div v-if="typeof item === 'object' && item !== null" class="grid-material-content">
                              <div class="grid-material-row" v-if="item.nameElement">
                                <span class="grid-material-label">材料名{{ itemIdx + 1 }}:</span>
                                <span class="grid-material-value">{{ item.nameElement }}</span>
                              </div>
                              <div class="grid-material-row" v-if="item.heaveyAll != null || item.quantityAll || item.quantity">
                                <span class="grid-material-label">总重量(KG):</span>
                                <span class="grid-material-value">
                                  {{ item.heaveyAll != null ? formatFieldValue('heaveyAll', item.heaveyAll) : (item.quantityAll ?? item.quantity ?? '--') }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
              
              <div class="grid-footer">
                <el-button type="primary" size="small"
                  :disabled="!row.imgListbyidlist || row.imgListbyidlist.length === 0" @click="showImageList(row)"
                  style="width: 100%;">
                  <el-icon>
                    <Picture />
                  </el-icon>
                  图片 ({{ row.imgListbyidlist ? row.imgListbyidlist.length : 0 }})
                </el-button>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <div v-if="tableData.length === 0" class="empty-grid">
        <el-empty description="暂无数据" />
      </div>
    </div>

    <!-- 列表视图 -->
    <div v-if="viewMode === 'list'" class="list-view-container" v-loading="loading">
      <el-scrollbar height="600px">
        <div class="list-item-wrapper" v-for="(row, index) in tableData" :key="index">
          <div class="list-item-card">
            <div class="list-item-header">
              <div class="list-item-title">
                <el-icon class="list-icon">
                  <Document />
                </el-icon>
                <span class="list-title-text">{{ getContractName(row) }}</span>
              </div>
              <el-button type="primary" size="small"
                :disabled="!row.imgListbyidlist || row.imgListbyidlist.length === 0" @click="showImageList(row)">
                查看图片 ({{ row.imgListbyidlist ? row.imgListbyidlist.length : 0 }})
              </el-button>
            </div>
            <div class="list-item-body">
               <div class="list-item-row" v-if="getContractWeightDisplay(row)">
                <span class="list-label">{{ isContractQuery ? '总重量(KG):' : '重量:' }}</span>
                <span class="list-value">{{ getContractWeightDisplay(row) }}</span>
              </div>
              <div class="list-item-row" v-if="getContractPriceDisplay(row)">
                <span class="list-label">{{ isContractQuery ? '总价格:' : '价格:' }}</span>
                <span class="list-value">{{ getContractPriceDisplay(row) }}</span>
              </div>
             
              <div class="list-item-row" v-if="row.brand">
                <span class="list-label">产品名:</span>
                <span class="list-value">{{ row.brand }}</span>
              </div>
              <div class="list-item-row" v-if="row.model">
                <span class="list-label">型号:</span>
                <span class="list-value">{{ row.model }}</span>
              </div>
              <div class="list-item-row" v-if="row.materialNumber">
                <span class="list-label">物料号:</span>
                <span class="list-value">{{ row.materialNumber }}</span>
              </div>
              <div class="list-item-row" v-if="row.manufacturer">
                <span class="list-label">制造商:</span>
                <span class="list-value">{{ row.manufacturer }}</span>
              </div>
              <div v-if="row.list && row.list.length > 0" class="list-item-details">
                <el-collapse>
                  <!-- 材料列表 (virtual == 0) -->
                  <el-collapse-item v-if="getMaterialList(row).length > 0 || getPlainItems(row.list).length > 0" :title="`材料列表 (${getMaterialList(row).length + getPlainItems(row.list).length} 项)`" :name="`list-material-${index}`">
                    <div class="list-material-table-wrapper">
                      <el-table
                        :data="getMaterialList(row)"
                        size="small"
                        border
                        stripe
                        :show-header="true"
                        style="width: 100%"
                        :header-cell-style="{ background: '#f5f7fa', color: '#606266', fontWeight: '600', textAlign: 'center' }"
                        :cell-style="{ textAlign: 'center', padding: '8px 4px' }"
                      >
                        <el-table-column prop="nameElement" label="材料名" min-width="120" align="center" show-overflow-tooltip>
                          <template #default="{ row: item }">
                            {{ item.nameElement || '--' }}
                          </template>
                        </el-table-column>
                           <el-table-column prop="heaveyAll" label="总重量(KG)" min-width="120" align="center">
                          <template #default="{ row: item }">
                            {{ item.heaveyAll != null ? formatFieldValue('heaveyAll', item.heaveyAll) : (item.quantityAll ?? item.quantity ?? '--') }}
                          </template>
                        </el-table-column>
                        <el-table-column prop="moneyALL" label="总价格" min-width="120" align="center">
                          <template #default="{ row: item }">
                            {{ item.moneyALL != null ? formatFieldValue('moneyALL', item.moneyALL) : '--' }}
                          </template>
                        </el-table-column>
                     
                      </el-table>
                      <div v-if="getPlainItems(row.list).length > 0" class="list-material-plain-items">
                        <div v-for="(item, itemIndex) in getPlainItems(row.list)" :key="itemIndex" class="list-material-plain-text">
                          {{ item }}
                        </div>
                      </div>
                    </div>
                  </el-collapse-item>
                  <!-- 虚拟列表 (virtual == 1) -->
                  <el-collapse-item v-if="getVirtualList(row).length > 0" :title="`虚拟列表 (${getVirtualList(row).length} 项)`" :name="`list-virtual-${index}`">
                    <div class="list-material-table-wrapper">
                      <el-table
                        :data="getVirtualList(row)"
                        size="small"
                        border
                        stripe
                        :show-header="true"
                        style="width: 100%"
                        :header-cell-style="{ background: '#f5f7fa', color: '#606266', fontWeight: '600', textAlign: 'center' }"
                        :cell-style="{ textAlign: 'center', padding: '8px 4px' }"
                      >
                        <el-table-column prop="nameElement" label="材料名" min-width="120" align="center" show-overflow-tooltip>
                          <template #default="{ row: item }">
                            {{ item.nameElement || '--' }}
                          </template>
                        </el-table-column>
                           <el-table-column prop="heaveyAll" label="总重量(KG)" min-width="120" align="center">
                          <template #default="{ row: item }">
                            {{ item.heaveyAll != null ? formatFieldValue('heaveyAll', item.heaveyAll) : (item.quantityAll ?? item.quantity ?? '--') }}
                          </template>
                        </el-table-column>
                        <el-table-column prop="moneyALL" label="总价格" min-width="120" align="center">
                          <template #default="{ row: item }">
                            {{ item.moneyALL != null ? formatFieldValue('moneyALL', item.moneyALL) : '--' }}
                          </template>
                        </el-table-column>
                     
                      </el-table>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </div>
          </div>
        </div>
      </el-scrollbar>
      <div v-if="tableData.length === 0" class="empty-list">
        <el-empty description="暂无数据" />
      </div>
    </div>

    <!-- 合同选择弹窗 -->
    <el-dialog v-model="showTenderDialog" :title="visiableshow==false?'选择合同':'合同可见性配置'" width="600px" :before-close="handleCloseTenderDialog">
      <div class="tender-select-container">
        <!-- 合同搜索框 -->
       <view style="display: flex;"> <el-input v-model="tenderSearchKeyword"
         placeholder="请输入合同名称搜索" clearable 
         @input="handleTenderSearch"
          style="margin-bottom: 15px;">
          <template #prefix>
            <el-icon>
              <Search />
            </el-icon>
          </template>
        </el-input>
              <el-button  style="margin-left: 10px;"  v-if="visiableshow" :type="visiabletype==1?'success':'defult'" 
                @click="findtenderlistbyvisiable(1)">可见</el-button>
            <el-button v-if="visiableshow" :type="visiabletype==0?'success':'defult'" @click="findtenderlistbyvisiable(0)">不可见</el-button>
          </view>
        <!-- 合同列表 -->
        <div class="tender-list-container">
          <div class="tender-select-all" v-if="tenderList.length > 0">
            <el-checkbox v-model="tenderCheckedAll" @change="handleTenderCheckAll">
              全选
            </el-checkbox>
      
          </div>
          <el-scrollbar height="300px">
            <el-checkbox-group v-model="tenderCheckedList">
              <div v-for="(item, index) in tenderList" :key="index" class="tender-item">
                <el-checkbox :label="item.bidId">
                  {{ item.bidName }}{{ item.display === 1 ? '(可见)' : '(不可见)' }}
                </el-checkbox>
              </div>
            </el-checkbox-group>
          </el-scrollbar>
        </div>

        <!-- 底部操作栏 -->
        <div class="tender-action-bar">
          <div class="tender-selected-count">
            <span>已选择</span>
            <span class="count-number">{{ tenderCheckedList.length }}</span>
            <span>条数据</span>
          </div>
          <div class="tender-action-buttons">
            <!-- <el-button type="primary" @click="confirmTenderSelectionOnly">确定选择</el-button> -->
            <el-button type="success" v-if="visiableshow" @click="confirmTenderSelectiondisplay(1)">设置可见</el-button>
            <el-button type="info" v-if="visiableshow" @click="confirmTenderSelectiondisplay(0)">设置不可见</el-button>
            <!-- <el-button type="success" @click="confirmTenderSelection(true)">导出文件</el-button> -->
            <el-button type="danger" @click="clearTenderSelection">清空选择</el-button>
          </div>
        </div>

      </div>
    </el-dialog>

    <!-- 图片展示弹窗 -->
    <el-dialog v-model="imageDialogVisible" title="图片列表" width="80%" :before-close="handleCloseImageDialog">
      <div v-if="currentImageList && currentImageList.length > 0" class="image-list-container">
        <el-row :gutter="20">
          <el-col v-for="(img, index) in currentImageList" :key="index" :xs="24" :sm="12" :md="8" :lg="6"
            style="margin-bottom: 20px;">
            <div class="image-item">
              <el-image :src="img" :preview-src-list="previewImageList" :initial-index="index" fit="cover" :lazy="true"
                class="image-preview" :preview-teleported="true">
                <template #error>
                  <div class="image-slot">
                    <el-icon>
                      <Picture />
                    </el-icon>
                    <div>加载失败</div>
                  </div>
                </template>
              </el-image>
            </div>
          </el-col>
        </el-row>
      </div>
      <div v-else class="empty-image">
        <el-empty description="暂无图片" />
      </div>
    </el-dialog>

    <!-- 分页 -->
    <div class="pagination-box">
      <el-pagination v-model:current-page="page" v-model:page-size="pageSize" :page-sizes="[5,10, 20, 50, 100]"
        :total="total" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </div>
  </div>
</template>

<script>
import { ElMessage } from 'element-plus';

import request from '@/api/api';
import {
  Box,
  Coin,
  Connection,
  Document,
  Eleme,
  Files,
  Goods,
  Grid,
  List,
  Location,
  Menu,
  Money,
  Picture,
  Scale,
  Search,
  Setting,
  Share,
  Shop,
  Star,
  Tools,
} from '@element-plus/icons-vue';

export default {
  name: 'TenderEntity',
  components: {
    Box,
    Coin,
    Connection,
    Document,
    Files,
    Goods,
    Grid,
    List,
    Location,
    Menu,
    Money,
    Picture,
    
    Search,
    Setting,
    Share,
    Shop,
    Star,
    Tools
  },
  data() {
    return {
      visiableshow:false,
      searchKeyword: '',
      tableData: [],
      loading: false,
      page: 1,
      pageSize: 5,
      total: 0,
      imageDialogVisible: false,
      currentImageList: [],
      viewMode: 'grid', // 'table' 或 'tree'
      treeProps: {
        children: 'children',
        label: 'label'
      },
      needupload:false,
      tableRef: null,
      // 合同选择相关
      showTenderDialog: false,
      tenderSearchKeyword: '',
      tenderList: [],
      tenderCheckedList: [],
      tenderCheckedAll: false,
      selectedTenderList: [],
      visiabletype:2,
    };
  },
  computed: {
    previewImageList() {
      return this.currentImageList || [];
    },
    selectedTenderIds() {
      if (!Array.isArray(this.selectedTenderList)) {
        return [];
      }
      return this.selectedTenderList
        .map(item => {
          if (typeof item === 'object' && item !== null) {
            return item.bidId ?? item.value ?? item.tenderId ?? item.tenderID ;
          }
          return item;
        })
        .filter(id => id !== undefined && id !== null && id !== '');
    },
    isContractQuery() {
          // return this.selectedTenderIds.length > 0;

      return false;
    },
    // 将表格数据转换为树状结构
    treeData() {
      if (!this.tableData || this.tableData.length === 0) {
        return [];
      }

      const tree = [];
      this.tableData.forEach((row, index) => {
        const contractName = this.getContractName(row);
        
        const rootNode = {
          id: `root-${index}`,
          label: contractName,
          type: 'root',
          children: []
        };

        // 处理非合同查询模式:单个产品
        if (!this.isContractQuery && row.brand) {
          // 构建产品节点标签:产品名 | 型号 | 制造商 | 重量
          const productParts = [];
          productParts.push(row.brand);
          if (row.model) productParts.push(`型号: ${row.model}`);
          if (row.manufacturer) productParts.push(`制造商: ${row.manufacturer}`);
          if (row.weight) productParts.push(`重量: ${row.weight}KG`);
          
          const productNode = {
            id: `product-${index}`,
            label: `产品1: ${productParts.join('   |   ')}`,
            type: 'product',
            children: []
          };
          rootNode.children.push(productNode);
          
          // 添加材料详情节点
          if (row.list && Array.isArray(row.list) && row.list.length > 0) {
            const materialDetailNode = {
              id: `material-detail-${index}`,
              label: '材料详情',
              type: 'material-detail',
              children: []
            };
            
            row.list.forEach((item, itemIndex) => {
              const materialIndex = itemIndex + 1;
              
              // 构建材料节点标签:材料名 | 重量 | 价格
              let materialLabel = item.nameElement ? `材料 ${materialIndex} : ${item.nameElement}` : `材料 ${materialIndex} : 材料项`;
              
              if (typeof item === 'object' && item !== null) {
                const materialParts = [];
                
                // 添加重量
                const weightValue = item.heaveyAll != null && item.heaveyAll !== '' 
                  ? this.formatFieldValue('heaveyAll', item.heaveyAll)
                  : (item.quantityAll ?? item.quantity ?? '');
                if (weightValue) {
                  materialParts.push(`重量: ${weightValue}KG`);
                }
                
                // 添加价格
                if (item.moneyALL != null && item.moneyALL !== '') {
                  materialParts.push(`价格: ${this.formatFieldValue('moneyALL', item.moneyALL)}`);
                }
                
                if (materialParts.length > 0) {
                  materialLabel += `   |   ${materialParts.join('   |   ')}`;
                }
              }
              
              const itemNode = {
                id: `item-${index}-${itemIndex}`,
                label: materialLabel,
                type: 'item',
                data: item,
                imgListbyidlist: row.imgListbyidlist,
                children: []
              };

              materialDetailNode.children.push(itemNode);
            });
            
            productNode.children.push(materialDetailNode);
          }
        }

        // 处理合同查询模式:详情条例
        if (this.isContractQuery) {
          const detailList = this.getContractDetailList(row);
          if (detailList && detailList.length > 0) {
            detailList.forEach((detail, detailIndex) => {
              // 构建产品节点标签:产品名 | 型号 | 制造商 | 重量
              const productParts = [];
              if (detail.brand) productParts.push(detail.brand);
              if (detail.model) productParts.push(`型号: ${detail.model}`);
              if (detail.manufacturer) productParts.push(`制造商: ${detail.manufacturer}`);
              if (detail.weight) productParts.push(`重量: ${detail.weight}KG`);
              
              const productNode = {
                id: `product-${index}-${detailIndex}`,
                label: `产品${detailIndex + 1}: ${productParts.join('   |   ')}`,
                type: 'product',
                children: []
              };
              rootNode.children.push(productNode);
              
              // 添加材料详情节点
              const materialList = this.getDetailMaterialList(detail);
              const virtualList = this.getDetailVirtualList(detail);
              const plainItems = this.getDetailPlainItems(detail);
              
              // 材料列表节点
              if (materialList && materialList.length > 0 || plainItems.length > 0) {
                const materialDetailNode = {
                  id: `material-detail-${index}-${detailIndex}`,
                  label: `材料列表 (${materialList.length + plainItems.length} 项)`,
                  type: 'material-detail',
                  children: []
                };
                
                materialList.forEach((item, itemIndex) => {
                  const materialIndex = itemIndex + 1;
                  
                  // 构建材料节点标签:材料名 | 重量 | 价格
                  let materialLabel = item.nameElement ? `材料 ${materialIndex} : ${item.nameElement}` : `材料 ${materialIndex} : 材料项`;
                  
                  if (typeof item === 'object' && item !== null) {
                    const materialParts = [];
                    
                    // 添加重量
                    const weightValue = item.heaveyAll != null && item.heaveyAll !== '' 
                      ? this.formatFieldValue('heaveyAll', item.heaveyAll)
                      : (item.quantityAll ?? item.quantity ?? '');
                    if (weightValue) {
                      materialParts.push(`重量: ${weightValue}KG`);
                    }
                    
                    // 添加价格
                    if (item.moneyALL != null && item.moneyALL !== '') {
                      materialParts.push(`价格: ${this.formatFieldValue('moneyALL', item.moneyALL)}`);
                    }
                    
                    if (materialParts.length > 0) {
                      materialLabel += `   |   ${materialParts.join('   |   ')}`;
                    }
                  }
                  
                  const itemNode = {
                    id: `item-${index}-${detailIndex}-${itemIndex}`,
                    label: materialLabel,
                    type: 'item',
                    data: item,
                    imgListbyidlist: row.imgListbyidlist,
                    children: []
                  };

                  materialDetailNode.children.push(itemNode);
                });
                
                // 添加纯文本项
                plainItems.forEach((item, itemIndex) => {
                  const plainNode = {
                    id: `plain-${index}-${detailIndex}-${itemIndex}`,
                    label: String(item),
                    type: 'item',
                    data: item,
                    imgListbyidlist: row.imgListbyidlist,
                    children: []
                  };
                  materialDetailNode.children.push(plainNode);
                });
                
                productNode.children.push(materialDetailNode);
              }
              
              // 虚拟列表节点
              if (virtualList && virtualList.length > 0) {
                const virtualDetailNode = {
                  id: `virtual-detail-${index}-${detailIndex}`,
                  label: `虚拟列表 (${virtualList.length} 项)`,
                  type: 'material-detail',
                  children: []
                };
                
                virtualList.forEach((item, itemIndex) => {
                  const materialIndex = itemIndex + 1;
                  
                  // 构建材料节点标签:材料名 | 重量 | 价格
                  let materialLabel = item.nameElement ? `材料 ${materialIndex} : ${item.nameElement}` : `材料 ${materialIndex} : 材料项`;
                  
                  if (typeof item === 'object' && item !== null) {
                    const materialParts = [];
                    
                    // 添加重量
                    const weightValue = item.heaveyAll != null && item.heaveyAll !== '' 
                      ? this.formatFieldValue('heaveyAll', item.heaveyAll)
                      : (item.quantityAll ?? item.quantity ?? '');
                    if (weightValue) {
                      materialParts.push(`重量: ${weightValue}KG`);
                    }
                    
                    // 添加价格
                    if (item.moneyALL != null && item.moneyALL !== '') {
                      materialParts.push(`价格: ${this.formatFieldValue('moneyALL', item.moneyALL)}`);
                    }
                    
                    if (materialParts.length > 0) {
                      materialLabel += `   |   ${materialParts.join('   |   ')}`;
                    }
                  }
                  
                  const itemNode = {
                    id: `virtual-item-${index}-${detailIndex}-${itemIndex}`,
                    label: materialLabel,
                    type: 'item',
                    data: item,
                    imgListbyidlist: row.imgListbyidlist,
                    children: []
                  };

                  virtualDetailNode.children.push(itemNode);
                });
                
                productNode.children.push(virtualDetailNode);
              }
            });
          }
        }

        tree.push(rootNode);
      });

      return tree;
    }
  },
  mounted() {
      this.tenderSearchKeyword=''
    this.refreshData();
    // 初始化表格列宽调整功能
    this.$nextTick(() => {
    this.handleTenderSearch()

      this.initTableResizable();
    });
  },
  watch: {

    showTenderDialog :{
    handler(newVal, oldVal) {
      
        console.log(newVal,oldVal);
        
        // 关闭合同选择弹窗时清空搜索关键字和合同列表
      this.tenderSearchKeyword='全部'
        this.handleTenderSearch();
      
    }},
    // 监听页码或每页条数变化时重新获取数据
    page(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.refreshData();
      }
    },
    // pageSize(newVal, oldVal) {
    //   if (newVal !== oldVal) {
    //     this.refreshData();
    //   }
    // },
    searchKeyword(newVal, oldVal) {
      this.selectedTenderList=[]
    },
    // 监听合同复选框变化
    tenderCheckedList() {
      this.updateTenderCheckedAll();
      this.syncTenderCheckedState();
    }
  },
  methods: {
    getContractName(row) {
      if (!row) return '未知';
      return (
        row.tenderName ||
        row.name ||
        row.contractName ||
        row.title ||
        row.tenderBatchName ||
        '未知'
      );
    },
    getFirstValidValue(values) {
      if (!Array.isArray(values)) return undefined;
      return values.find(value => value !== undefined && value !== null && value !== '');
    },
    getContractPriceValue(row) {
      if (!row) return undefined;
      return this.getFirstValidValue([
        row.priceAll,
        row.moneyAll,
        row.totalPrice,
        row.totalMoney,
        row.price
      ]);
    },
    getContractWeightValue(row) {
      if (!row) return undefined;
      return this.getFirstValidValue([row.heaveyAll, row.totalWeight, row.weight]);
    },
    formatContractPrice(value) {
      if (value === undefined || value === null || value === '') return '';
      return this.formatFieldValue('moneyALL', value);
    },
    formatContractWeight(value) {
      if (value === undefined || value === null || value === '') return '';
      return `${this.formatFieldValue('heaveyAll', value)} KG`;
    },
    getContractPriceDisplay(row) {
      const value = this.getContractPriceValue(row);
      if (value === undefined || value === null || value === '') {
        return '';
      }
      return this.formatContractPrice(value);
    },
    getContractWeightDisplay(row) {
      const value = this.getContractWeightValue(row);
      if (value === undefined || value === null || value === '') {
        return '';
      }
      return this.formatContractWeight(value);
    },
    getContractDetailList(row) {
      if (!row) return [];
      const list = row.bidBrandNameVoList || row.bidBrandNameList || [];
      return Array.isArray(list) ? list : [];
    },
    getDetailMaterialList(detail) {
      if (!detail) return [];
      const list = detail.list || detail.materialList || [];
      if (!Array.isArray(list)) return [];
      // 返回材料列表(virtual == 0)
      return list.filter(item => {
        if (typeof item !== 'object' || item === null) return false;
        const virtual = item.virtual;
        return virtual === 0 || virtual === '0' || virtual === undefined || virtual === null;
      });
    },
    // 获取详情条例中的虚拟列表(virtual == 1)
    getDetailVirtualList(detail) {
      if (!detail) return [];
      const list = detail.list || detail.materialList || [];
      if (!Array.isArray(list)) return [];
      return list.filter(item => {
        if (typeof item !== 'object' || item === null) return false;
        return item.virtual === 1 || item.virtual === '1';
      });
    },
    // 获取详情条例中的非对象类型列表项(用于显示纯文本)
    getDetailPlainItems(detail) {
      if (!detail) return [];
      const list = detail.list || detail.materialList || [];
      if (!Array.isArray(list)) return [];
      return list.filter(item => typeof item !== 'object' || item === null);
    },
    // 获取材料列表(virtual == 0)
    getMaterialList(row) {
      if (!row || !row.list || !Array.isArray(row.list)) return [];
      return row.list.filter(item => {
        if (typeof item !== 'object' || item === null) return false;
        // virtual === 0 或 '0' 或 undefined 或 null 都视为材料列表
        const virtual = item.virtual;
        return virtual === 0 || virtual === '0' || virtual === undefined || virtual === null;
      });
    },
    // 获取虚拟列表(virtual == 1)
    getVirtualList(row) {
      if (!row || !row.list || !Array.isArray(row.list)) return [];
      return row.list.filter(item => {
        if (typeof item !== 'object' || item === null) return false;
        return item.virtual === 1 || item.virtual === '1';
      });
    },
    // 获取非对象类型的列表项(用于显示纯文本)
    getPlainItems(list) {
      if (!Array.isArray(list)) return [];
      return list.filter(item => typeof item !== 'object' || item === null);
    },
    // 获取合同查询模式下所有详情条例的材料列表汇总(virtual == 0)
    getContractMaterialList(row) {
      if (!row) return [];
      const detailList = this.getContractDetailList(row);
      if (!detailList || detailList.length === 0) {
        // 如果没有详情条例,使用原来的逻辑
        return this.getMaterialList(row);
      }
      // 汇总所有详情条例的材料列表
      const allMaterials = [];
      detailList.forEach(detail => {
        const materials = this.getDetailMaterialList(detail);
        allMaterials.push(...materials);
      });
      return allMaterials;
    },
    // 获取合同查询模式下所有详情条例的虚拟列表汇总(virtual == 1)
    getContractVirtualList(row) {
      if (!row) return [];
      const detailList = this.getContractDetailList(row);
      if (!detailList || detailList.length === 0) {
        // 如果没有详情条例,使用原来的逻辑
        return this.getVirtualList(row);
      }
      // 汇总所有详情条例的虚拟列表
      const allVirtuals = [];
      detailList.forEach(detail => {
        const virtuals = this.getDetailVirtualList(detail);
        allVirtuals.push(...virtuals);
      });
      return allVirtuals;
    },
    // 获取合同查询模式下所有详情条例的纯文本项汇总
    getContractPlainItems(row) {
      if (!row) return [];
      const detailList = this.getContractDetailList(row);
      if (!detailList || detailList.length === 0) {
        // 如果没有详情条例,使用原来的逻辑
        return this.getPlainItems(row.list || []);
      }
      // 汇总所有详情条例的纯文本项
      const allPlainItems = [];
      detailList.forEach(detail => {
        const plainItems = this.getDetailPlainItems(detail);
        allPlainItems.push(...plainItems);
      });
      return allPlainItems;
    },
    formatDetailField(value) {
      if (value === undefined || value === null || value === '') {
        return '--';
      }
      return value;
    },
    formatDetailWeight(value) {
      if (value === undefined || value === null || value === '') {
        return '--';
      }
      const num = parseFloat(value);
      if (isNaN(num)) {
        return value;
      }
      return `${num.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} KG`;
    },
    // 保存合同选择到selectedTenderList
    saveTenderSelection() {
      const checkedSet = new Set(this.tenderCheckedList);
      const visibleIds = new Set((this.tenderList || []).map(item => item.bidId));

      const preserved = this.selectedTenderList.filter(item => {
        const id = item.bidId
        if (visibleIds.has(id)) {
          return checkedSet.has(id);
        }
        return true;
      });

      const mergedMap = new Map();
      preserved.forEach(item => {
        const id = item.bidId
        if (id !== undefined && id !== null) {
          mergedMap.set(id, { ...item, checked: true });
        }
      });

      (this.tenderList || []).forEach(item => {
        if (checkedSet.has(item.bidId)) {
          const id = item.bidId ?? item.value;
          mergedMap.set(id, { ...item, checked: true, value: item.value ?? item.bidId });
        }
      });

      this.selectedTenderList = Array.from(mergedMap.values());
      console.log('保存选择后的selectedTenderList:', this.selectedTenderList);
    },

    // 根据合同选择动态调用接口
    refreshData() {
      // 如果对话框是打开的,先保存选择
      if (this.showTenderDialog) {
        this.saveTenderSelection();
        this.showTenderDialog = false;
      }
      
      // 重新查询时重置页码并清空数据
      // this.page = 1;
      // this.tableData = [];
      
      console.log('查询时的selectedTenderList:', this.selectedTenderList);

      if (this.selectedTenderList.length > 0) {
        // 有合同选择时,只调用合同查询接口
        this.fetchData();
      } else {
        // 没有合同选择时,调用普通查询接口
        this.fetchData();
      }
    },

    // 获取数据
    async fetchData() {
      this.loading = true;
      try {
         let stringids=''
           if(this.selectedTenderList.length>0){
                    stringids=this.selectedTenderList.map(item=>item.bidId).join(',')

           }
        const params = {
          page: this.page,
          bidids:stringids,
          pageSize: this.pageSize,
          status: 3,
          source: 1,
          keyword: this.searchKeyword || '',
          tenderEntityList: this.selectedTenderList.length > 0 ? this.selectedTenderList : undefined
        };

        const response = await request('/BidBrand/findbypage', 'post', params);

        console.log('接口返回数据:', response);

        // 根据实际返回的数据结构处理
        if (response && response.data) {
          const data = response.data;
          // 如果返回的是分页对象,包含 records 或 list 字段
          if (data.records) {
            this.tableData = data.records;
            this.total = data.total || 0;
          } else if (data.list) {
            this.tableData = data.list;
            this.total = data.total || 0;
          } else if (Array.isArray(data)) {
            this.tableData = data;
            this.total = data.length;
          } else if (data.data) {
            // 嵌套的 data 结构
            if (Array.isArray(data.data)) {
              this.tableData = data.data;
              this.total = data.total || data.data.length;
            } else if (data.data.records) {
              this.tableData = data.data.records;
              this.total = data.data.total || 0;
            } else if (data.data.list) {
              this.tableData = data.data.list;
              this.total = data.data.total || 0;
            }
          } else {
            this.tableData = [];
            this.total = 0;
          }
        } else {
          this.tableData = [];
          this.total = 0;
        }
      } catch (error) {
        console.error('获取数据失败:', error);
        ElMessage.error('获取数据失败: ' + (error.message || '未知错误'));
        this.tableData = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },
async uploadfile(){

  request('/productStore/exporttableforbidBrand', 'post',this.tableData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }).then(response => {
    console.log('文件上传成功:', response);
        // 处理 base64 数据并下载文件
        if (response.data && response.data.data) {
          const base64Data = response.data.data.toString().trim().replace(/\s/g, '')
          console.log('📄 获取到 base64 数据:', base64Data.substring(0, 100) + '...')

          // 下载文件
          this.downloadFileFromBase64(base64Data, `投标品牌列表_${new Date().toISOString().slice(0,10)}.csv`)
          // ElMessage.success('文件处理成功,文件已下载!')
        } else {
          // ElMessage.success('文件处理成功!')
        }
  }).catch(error => {
    console.error('文件上传失败:', error);
  });
},   
 // 桌面端下载方法(支持自动下载到桌面文件夹)
    async downloadForDesktop(base64Data, filename, mimeType) {
      try {
        // 将 base64 转换为 Blob
        const byteCharacters = atob(base64Data)
        const byteNumbers = new Array(byteCharacters.length)

        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }

        const byteArray = new Uint8Array(byteNumbers)
        const blob = new Blob([byteArray], { type: mimeType })

        // 尝试使用 File System Access API 保存到指定文件夹
        // 只有在用户已经选择文件夹的情况下才使用
        if (this.savedDirectoryHandle && 'showDirectoryPicker' in window) {
          try {
            // 尝试保存文件到选择的文件夹(如果句柄无效会在这里失败)
            const fileHandle = await this.savedDirectoryHandle.getFileHandle(filename, { create: true })
            const writable = await fileHandle.createWritable()
            await writable.write(blob)
            await writable.close()

            console.log('✅ 文件已保存到指定文件夹:', filename)
            // ElMessage.success('文件已自动下载到桌面文件夹!')
            return
          } catch (writeError) {
            // 写入失败,可能是句柄无效,清除句柄并使用默认下载方式
            console.log('写入文件失败,可能是文件夹句柄无效:', writeError)
            this.savedDirectoryHandle = null
            ElMessage.warning('文件夹句柄已失效,请重新选择文件夹.本次使用默认下载方式.')
            // 继续执行默认下载方式
          }
        }

        // 默认下载方式(浏览器默认下载文件夹)
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = filename
        link.style.display = 'none'

        // 触发下载
        document.body.appendChild(link)
        link.click()

        // 清理
        setTimeout(() => {
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        }, 1000)

        console.log('✅ 桌面端文件下载完成:', filename)
        // ElMessage.success('文件下载成功!')

      } catch (error) {
        console.error('❌ 桌面端下载失败:', error)
        ElMessage.error('桌面端下载失败: ' + error.message)
      }
    },
// 从 base64 数据下载文件(手机端兼容版)
    downloadFileFromBase64(base64Data, filename) {
      try {
        console.log('📥 开始下载文件:', filename)
        console.log('📱 设备信息:', {
          userAgent: navigator.userAgent,
          isMobile: this.isMobile,
          isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent),
          isAndroid: /Android/.test(navigator.userAgent)
        })

        // 检测文件类型
        let mimeType = 'application/octet-stream'
        let fileExtension = '.csv'

        // 根据 base64 数据头判断文件类型
        if (base64Data.startsWith('data:')) {
          // 如果包含 data URL 前缀,提取 MIME 类型
          const mimeMatch = base64Data.match(/^data:([^;]+);base64,/)
          if (mimeMatch) {
            mimeType = mimeMatch[1]
            base64Data = base64Data.replace(/^data:[^;]+;base64,/, '')

            // 根据 MIME 类型确定文件扩展名
            if (mimeType.includes('csv')) {
              fileExtension = '.csv'
            } else if (mimeType.includes('excel') || mimeType.includes('spreadsheet')) {
              fileExtension = '.xlsx'
            } else if (mimeType.includes('pdf')) {
              fileExtension = '.pdf'
            }
          }
        }

        // 确保文件名有正确的扩展名
        if (!filename.includes('.')) {
          filename += fileExtension
        }

        console.log('📄 文件信息:', {
          filename: filename,
          mimeType: mimeType,
          base64Length: base64Data.length
        })

        // 根据设备类型选择下载方式

        this.downloadForDesktop(base64Data, filename, mimeType)


      } catch (error) {
        console.error('❌ 文件下载失败:', error)
        ElMessage.error('文件下载失败: ' + error.message)
      }
    },
    async fetchData2() {

      this.loading = true;
      try {
        const params = {
          page: this.page,
          pageSize: this.pageSize,
          tenderEntityList: this.selectedTenderList
        };

        const response = await request('/productStore/reportbidBrandListPage', 'post', params);

        console.log('合同查询接口返回数据:', response);

        if (response && response.data) {
          const data = response.data.data;
          let newData = [];
          
          if (data.records) {
            newData = data.records;
            this.total = data.total || 0;
          } 
          
          
          // 分页处理:第一页清空,后续页追加
          if (this.page === 1) {
            this.tableData = newData;
          } else {
            this.tableData.push(...newData);
          }
          
          if (!newData || newData.length === 0) {
            this.total = 0;
          }

          if(this.needupload==true){
            this.uploadfile()
            this.needupload=false
          }
        } else {
          this.tableData = [];
          this.total = 0;
        }
      } catch (error) {
        console.error('合同查询接口数据获取失败:', error);
        ElMessage.error('合同查询失败: ' + (error.message || '未知错误'));
        this.tableData = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },

    // 搜索
    handleSearch() {
      // selectedTenderList.length > 0
      // this.clearTenderSelection()
      this.page = 1; // 重置到第一页
      this.refreshData();
    },

    // 分页大小改变
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.refreshData();
    },

    // 当前页改变
    handleCurrentChange(val) {
      this.page = val;
      this.refreshData();
    },

    // 显示图片列表
    showImageList(payload) {
      // 兼容表格数据、树状图数据以及直接传入图片数组的情况
      let imgList = [];
      if (Array.isArray(payload)) {
        imgList = payload;
      } else if (payload && Array.isArray(payload.imgListbyidlist)) {
        imgList = payload.imgListbyidlist;
      } else if (payload && Array.isArray(payload.imglist)) {
        imgList = payload.imglist;
      }

      if (imgList && imgList.length > 0) {
        this.currentImageList = imgList.map(img => {
          return img.image || img;
        });
        this.imageDialogVisible = true;
      } else {
        ElMessage.warning('该记录暂无图片');
      }
    },

    // 格式化列表项标签
    formatListItemLabel(item) {
      if (typeof item === 'object' && item !== null) {
        // 优先显示材料名
        if (item.nameElement) {
          let label = `材料: ${item.nameElement}`;
          if (item.moneyALL) {
            label += ` | 总价格: ${this.formatFieldValue('moneyALL', item.moneyALL)}`;
          }
          if (item.heaveyAll) {
            label += ` | 总重量(KG): ${this.formatFieldValue('heaveyAll', item.heaveyAll)}`;
          }
          return label;
        }
        // 如果没有材料名,显示第一个有值的字段
        const firstKey = Object.keys(item).find(key => item[key] !== null && item[key] !== undefined && item[key] !== '');
        if (firstKey) {
          return `${this.getFieldLabel(firstKey)}: ${this.formatFieldValue(firstKey, item[firstKey])}`;
        }
        return '列表项';
      }
      return String(item);
    },

    // 关闭图片弹窗
    handleCloseImageDialog() {
      this.imageDialogVisible = false;
      this.currentImageList = [];
    },

    // 获取字段中文标签
    getFieldLabel(key) {
      const labelMap = {
        'nameElement': '材料名',
        'moneyALL': '总价格',
        'heaveyAll': '总重量(KG)',
        'quantity': '重量',

      };
      return labelMap[key] || key;
    },

    // 格式化字段值
    formatFieldValue(key, value) {
      // 如果是价格字段,格式化显示
      if (key === 'moneyALL' && value !== null && value !== undefined) {
        const num = parseFloat(value);
        if (!isNaN(num)) {
          return '¥' + num.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
      }
      // 如果是重量字段,格式化显示
      if (key === 'heaveyAll' && value !== null && value !== undefined) {
        const num = parseFloat(value);
        if (!isNaN(num)) {
          return num.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
      }
      return value;
    },

    // 处理表头点击(用于排序等)
    handleHeaderClick(column, event) {
      // 可以在这里添加排序功能
      console.log('点击表头:', column);
    },

    // 初始化表格列宽调整
    initTableResizable() {
      // Element Plus 表格默认支持列宽调整,通过 CSS 实现
      // 这里可以添加额外的初始化逻辑
    },

    // 处理合同搜索this.tenderSearchKeyword
    async handleTenderSearch() {
     
        try {
          const response = await request('/BidBrand/findtenderlist', 'post', {
            keyWords: this.tenderSearchKeyword
          });

          if (response && response.data && response.data.data) {
            const selectedIds = this.selectedTenderIds;
            this.tenderList = response.data.data.map(v => {
              const id = v.bidId ?? v.value;
              const isChecked = selectedIds.includes(id);
              return {
                ...v,
                value: v.value ?? v.bidId,
                checked: isChecked
              };
            });
            this.tenderCheckedList = this.tenderList
              .filter(item => item.checked)
              .map(item => item.bidId);
            this.updateTenderCheckedAll();
            this.syncTenderCheckedState();
          }
        } catch (error) {
          console.error('查询合同列表失败:', error);
          ElMessage.error('查询合同列表失败');
        }
      
    },
      async findtenderlistbyvisiable(type) {
        let keywords=type
        this.visiabletype=type

        if(type==1){
          keywords='可见'
        }else{
          keywords='不可见'
        }
      
        try {
          const response = await request('/BidBrand/findtenderlistbyvisiable', 'post', {
            keyWords: keywords
          });

          if (response && response.data && response.data.data) {
            const selectedIds = this.selectedTenderIds;
            this.tenderList = response.data.data.map(v => {
              const id = v.bidId ?? v.value;
              const isChecked = selectedIds.includes(id);
              return {
                ...v,
                value: v.value ?? v.bidId,
                checked: isChecked
              };
            });
            this.tenderCheckedList = this.tenderList
              .filter(item => item.checked)
              .map(item => item.bidId);
            this.updateTenderCheckedAll();
            this.syncTenderCheckedState();
          }
        } catch (error) {
          console.error('查询合同列表失败:', error);
          ElMessage.error('查询合同列表失败');
        }
     
    },

    // 合同全选/取消全选
    handleTenderCheckAll(val) {
      if (val) {
        this.tenderCheckedList = this.tenderList.map(item => item.bidId);
      } else {
        this.tenderCheckedList = [];
      }
      this.syncTenderCheckedState();
    },

    // 更新全选状态
    updateTenderCheckedAll() {
      if (this.tenderList.length === 0) {
        this.tenderCheckedAll = false;
        return;
      }
      this.tenderCheckedAll = this.tenderList.every(item =>
        this.tenderCheckedList.includes(item.bidId)
      );
    },
    toweixin(){
          
    },

    syncTenderCheckedState() {
      if (!Array.isArray(this.tenderList) || this.tenderList.length === 0) {
        return;
      }
      const checkedSet = new Set(this.tenderCheckedList);
      this.tenderList = this.tenderList.map(item => ({
        ...item,
        checked: checkedSet.has(item.id)
      }));
    },

    // 清空合同选择
    clearTenderSelection() {
      if(!this.visiableshow){
             this.tenderCheckedList = [];
      this.selectedTenderList = [];
      this.tenderCheckedAll = false;
      this.page = 1;
      this.syncTenderCheckedState();
      this.refreshData();
      }else{
           this.tenderCheckedList = [];
      this.selectedTenderList = [];
      this.tenderCheckedAll = false;

      }
 
    },
    // 显示确认合同可见性
    confirmTenderSelectiondisplay(type){
      // 先保存选择
      this.saveTenderSelection();
      
      console.log('selectedTenderList',this.selectedTenderList);
      for(let i=0;i<this.selectedTenderList.length;i++){
        request('/bid/updatebyid', 'post', {
          bidId:this.selectedTenderList[i].bidId,
          display:type,
        }).then(response => {
          console.log(response.data.data,'display;1');
         ElMessage.success('设置成功');
         this.findtenderlistbyvisiable(type)
          //  this.showTenderDialog = false;
      // this.page = 1;
      // this.refreshData();
      // this.handleTenderSearch()
        })
      }
     
    },

    // 只确认合同选择,不执行其他操作(已废弃,使用saveTenderSelection代替)
    confirmTenderSelectionOnly() {
      this.saveTenderSelection();
      this.showTenderDialog = false;
      this.refreshData();
    },

    // 确认合同选择
    confirmTenderSelection(type) {
      this.needupload = type;
      // 先保存选择
      this.saveTenderSelection();
      this.showTenderDialog = false;
      // this.page = 1;
      // this.refreshData();
    },

    // 关闭合同选择弹窗
    handleCloseTenderDialog() {
      // 关闭时自动保存选择,确保selectedTenderList被更新
      this.saveTenderSelection();
      this.syncTenderCheckedState();
      this.tenderSearchKeyword = '';
      this.showTenderDialog = false;
    }
  }
};
</script>

<style lang="less" scoped>
// 现代化配色方案
@primary-color: #409eff;
@primary-light: #66b1ff;
@primary-dark: #337ecc;
@success-color: #67c23a;
@warning-color: #e6a23c;
@danger-color: #f56c6c;
@info-color: #909399;
@text-primary: #303133;
@text-regular: #606266;
@text-secondary: #909399;
@text-placeholder: #c0c4cc;
@border-base: #dcdfe6;
@border-light: #e4e7ed;
@border-lighter: #ebeef5;
@border-extra-light: #f2f6fc;
@bg-color: #ffffff;
@bg-page: #f5f7fa;
@shadow-base: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
@shadow-light: 0 2px 8px 0 rgba(0, 0, 0, 0.08);
@shadow-dark: 0 4px 16px 0 rgba(0, 0, 0, 0.12);

.tender-entity {
  padding: 24px;
  background: linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%);
  min-height: 100vh;
}

// 搜索框区域美化
.search-box {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  padding: 20px;
  background: @bg-color;
  border-radius: 12px;
  box-shadow: @shadow-light;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: @shadow-base;
  }

  .el-button {
    border-radius: 8px;
    font-weight: 500;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
    }
  }

  .el-input {
    border-radius: 8px;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }

    :deep(.el-input__wrapper) {
      border-radius: 8px;
      box-shadow: 0 0 0 1px @border-lighter inset;
      transition: all 0.3s ease;

      &:hover {
        box-shadow: 0 0 0 1px @primary-light inset;
      }

      &.is-focus {
        box-shadow: 0 0 0 1px @primary-color inset, 0 0 0 3px rgba(64, 158, 255, 0.1);
      }
    }
  }

  .el-radio-group {
    .el-radio-button {
      border-radius: 8px;
      margin-left: 8px;
      overflow: hidden;
      transition: all 0.3s ease;

      &:first-child {
        margin-left: 0;
      }

      .el-radio-button__inner {
        border-radius: 8px;
        padding: 10px 16px;
        font-weight: 500;
        transition: all 0.3s ease;
      }

      &.is-active .el-radio-button__inner {
        background: linear-gradient(135deg, @primary-color 0%, @primary-light 100%);
        box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
      }
    }
  }
}

.pagination-box {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

/* 表格容器 */
.table-container {
  margin-top: 24px;
  background: @bg-color;
  border-radius: 12px;
  padding: 20px;
  box-shadow: @shadow-base;
  transition: all 0.3s ease;
}

/* 合同名称单元格样式 - 允许换行 */
.contract-name-cell {
  word-wrap: break-word;
  word-break: break-all;
  white-space: normal;
  line-height: 1.6;
  padding: 8px 12px;
  color: @text-primary;
  font-weight: 500;
}

/* 表格优化样式 */
:deep(.el-table) {
  border-radius: 8px;
  overflow: hidden;
  background: @bg-color;

  .el-table__cell {
    padding: 16px 12px;
    border-color: @border-lighter;
  }

  /* 表头样式优化 */
  .el-table__header-wrapper {
    .el-table__header {
      th {
        background: linear-gradient(135deg, #f8f9fa 0%, #f0f2f5 100%);
        color: @text-primary;
        font-weight: 600;
        font-size: 14px;
        border-bottom: 2px solid @border-light;
        padding: 16px 12px;
        text-align: center;
        position: relative;

        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          width: 3px;
          background: linear-gradient(180deg, @primary-color 0%, @primary-light 100%);
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        &:hover::before {
          opacity: 1;
        }
      }
    }
  }

  /* 表格行悬停效果 */
  .el-table__body {
    tr {
      transition: all 0.3s ease;

      &:hover>td {
        background: linear-gradient(90deg, rgba(64, 158, 255, 0.05) 0%, rgba(64, 158, 255, 0.02) 100%) !important;
        transform: scale(1.001);
      }

      td {
        border-color: @border-lighter;
      }
    }
  }

  /* 合同名列单元格允许换行 */
  .el-table__body-wrapper {
    .el-table__body {
      tbody {
        tr {
          td:first-child {
            .el-table__cell {
              white-space: normal !important;
              word-wrap: break-word;
              word-break: break-all;
            }
          }
        }
      }
    }
  }

  /* 列宽调整手柄样式 */
  .el-table__header-wrapper {
    .el-table__header {
      th {
        position: relative;

        &::after {
          content: '';
          position: absolute;
          right: 0;
          top: 0;
          bottom: 0;
          width: 4px;
          cursor: col-resize;
          background: transparent;
          transition: background 0.2s;
        }

        &:hover::after {
          background: #409eff;
        }
      }
    }
  }

  /* 固定列阴影优化 */
  .el-table__fixed,
  .el-table__fixed-right {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }

  /* 表格边框优化 */
  &.el-table--border {
    border: 1px solid #ebeef5;

    &::after {
      background-color: #ebeef5;
    }

    &::before {
      background-color: #ebeef5;
    }
  }

  /* 斑马纹优化 */
  &.el-table--striped {
    .el-table__body {
      tr.el-table__row--striped {
        td {
          background-color: #fafafa;
        }
      }
    }
  }
}

.list-data {
  max-height: 300px;
  overflow-y: auto;
}

.material-summary-table-wrapper {
  width: 100%;
  
  :deep(.el-table) {
    border-radius: 6px;
    overflow: hidden;
    
    .el-table__header-wrapper {
      .el-table__header {
        th {
          background: linear-gradient(135deg, #f8f9fa 0%, #f0f2f5 100%);
          color: #606266;
          font-weight: 600;
          font-size: 13px;
          padding: 10px 4px;
          border-bottom: 2px solid #e4e7ed;
        }
      }
    }
    
    .el-table__body-wrapper {
      .el-table__body {
        tr {
          transition: all 0.3s ease;
          
          &:hover > td {
            background: linear-gradient(90deg, rgba(64, 158, 255, 0.05) 0%, rgba(64, 158, 255, 0.02) 100%) !important;
          }
          
          td {
            border-color: #ebeef5;
            font-size: 13px;
          }
        }
      }
    }
    
    &.el-table--striped {
      .el-table__body {
        tr.el-table__row--striped {
          td {
            background-color: #fafafa;
          }
        }
      }
    }
  }
  
  .material-plain-items {
    margin-top: 8px;
    
    .material-plain-text {
      padding: 6px 12px;
      background: #f5f7fa;
      border-radius: 4px;
      margin-bottom: 4px;
      font-size: 13px;
      color: #606266;
      text-align: center;
    }
  }
}

.detail-column {
  // background-color: #62789a58;
  
  display: flex;
  flex-direction: column;
  // gap: 8px;
  text-align: left;
}

.detail-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  font-size: 13px;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  padding: 16px;
  margin-bottom: 12px;
  border-radius: 10px;
  border: 1px solid @border-lighter;
  box-shadow: @shadow-light;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    background: linear-gradient(180deg, @primary-color 0%, @primary-light 100%);
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover {
    box-shadow: @shadow-base;
    transform: translateX(4px);
    border-color: @primary-light;

    &::before {
      opacity: 1;
    }
  }

  &:last-child {
    margin-bottom: 0;
  }
}

.detail-item + .detail-item {
  margin-top: 8px;
  border-top: 1px dashed @border-base;
  padding-top: 16px;
}

.detail-index {
  width: 28px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  border-radius: 50%;
  background: linear-gradient(135deg, @primary-color 0%, @primary-light 100%);
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  margin-right: 16px;
  margin-top: 2px;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
  flex-shrink: 0;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
  }
}

.detail-info {
  display: flex;
  flex-direction: column;
  row-gap: 4px;
  flex: 1;
}

.detail-info-row {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
}

.detail-material-row {
  align-items: flex-start;
  flex-wrap: nowrap;
}

.detail-material-value {
  flex: 1;
  min-width: 0;
}

.detail-label {
  color: @text-secondary;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.detail-icon {
  font-size: 14px;
  color: @primary-color;
  transition: all 0.3s ease;
}

.detail-info-row:hover .detail-icon {
  color: @primary-light;
  transform: scale(1.1);
}

.detail-value {
  color: #303133;
  margin-right: 24px;
}

.detail-item span {
  white-space: nowrap;
}

/* 详情条例中材料名与数值的字号区分 */
:deep(.detail-column .el-descriptions__label) {
  font-size: 12px;
  color: #909399;
  font-weight: 400;
}

:deep(.detail-column .el-descriptions__content) {
  font-size: 14px;
  color: #303133;
  font-weight: 600;
}

.list-item {
  margin-bottom: 10px;
  padding: 12px 16px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-radius: 8px;
  border: 1px solid @border-lighter;
  box-shadow: @shadow-light;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: @shadow-base;
    transform: translateX(2px);
    border-color: @primary-light;
  }
}

.list-item:last-child {
  margin-bottom: 0;
}

:deep(.el-descriptions) {
  margin: 0;
}

:deep(.list-item .el-descriptions__cell) {
  padding-top: 6px;
  padding-bottom: 6px;
  vertical-align: middle;
}

:deep(.el-descriptions__label) {
  font-weight: 500;
  width: 100px;
}

.image-list-container {
  max-height: 70vh;
  overflow-y: auto;
  padding: 10px;
}

.image-item {
  position: relative;
  width: 100%;
  padding-top: 100%;
  /* 1:1 宽高比 */
  background-color: #f5f7fa;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s;
}

.image-item:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.image-preview {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.image-slot {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 14px;
}

.image-slot .el-icon {
  font-size: 30px;
  margin-bottom: 10px;
}

.empty-image {
  padding: 40px 0;
  text-align: center;
}

:deep(.el-dialog__body) {
  padding: 20px;
}

.tree-view-container {
  margin-top: 24px;
  padding: 24px;
  background: @bg-color;
  border-radius: 12px;
  min-height: 400px;
  box-shadow: @shadow-base;
  border: 1px solid @border-lighter;
}

.tree-node-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-right: 20px;
}

.tree-node-label {
  flex: 1;
  font-size: 14px;
}

.tree-node-actions {
  margin-left: 10px;
}

.empty-tree {
  padding: 40px 0;
  text-align: center;
}

:deep(.el-tree-node__content) {
  height: 40px;
  line-height: 40px;
}

:deep(.el-tree-node__label) {
  font-size: 14px;
}

/* 网格视图样式 */
.grid-view-container {
  margin-top: 20px;
}

.grid-item {
  background: linear-gradient(135deg, #ffffff 0%, #fafbfc 100%);
  border: 1px solid @border-lighter;
  border-radius: 12px;
  padding: 20px;
  height: 100%;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  position: relative;
  overflow: hidden;
  box-shadow: @shadow-light;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, @primary-color 0%, @primary-light 100%);
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover {
    border-color: @primary-color;
    box-shadow: @shadow-dark;
    transform: translateY(-4px) scale(1.02);

    &::before {
      opacity: 1;
    }
  }
}

.grid-header {
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #ebeef5;
}

.grid-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.grid-body {
  margin-bottom: 12px;
}

.grid-info {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  font-size: 14px;
  color: #606266;
}

.grid-icon {
  margin-right: 8px;
  color: #409eff;
  font-size: 16px;
}

.grid-footer {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #ebeef5;
}

.empty-grid {
  padding: 40px 0;
  text-align: center;
}

/* 网格视图材料展开样式 */
.grid-material-section {
  margin-top: 12px;
  margin-bottom: 12px;
}

.grid-material-table-wrapper {
  width: 100%;
  
  :deep(.el-table) {
    border-radius: 6px;
    overflow: hidden;
    
    .el-table__header-wrapper {
      .el-table__header {
        th {
          background: linear-gradient(135deg, #f8f9fa 0%, #f0f2f5 100%);
          color: #606266;
          font-weight: 600;
          font-size: 13px;
          padding: 10px 4px;
          border-bottom: 2px solid #e4e7ed;
        }
      }
    }
    
    .el-table__body-wrapper {
      .el-table__body {
        tr {
          transition: all 0.3s ease;
          
          &:hover > td {
            background: linear-gradient(90deg, rgba(64, 158, 255, 0.05) 0%, rgba(64, 158, 255, 0.02) 100%) !important;
          }
          
          td {
            border-color: #ebeef5;
            font-size: 13px;
          }
        }
      }
    }
    
    &.el-table--striped {
      .el-table__body {
        tr.el-table__row--striped {
          td {
            background-color: #fafafa;
          }
        }
      }
    }
  }
  
  .grid-material-plain-items {
    margin-top: 8px;
    
    .grid-material-text {
      padding: 6px 12px;
      background: #f5f7fa;
      border-radius: 4px;
      margin-bottom: 4px;
      font-size: 13px;
      color: #606266;
      text-align: center;
    }
  }
}

:deep(.grid-material-section .el-collapse-item__header) {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
}

.grid-material-card {
  margin-bottom: 10px;
  padding: 12px 16px;
  background: linear-gradient(135deg, #ffffff 0%, #fafbfc 100%);
  border: 1px solid @border-lighter;
  border-radius: 8px;
  box-shadow: @shadow-light;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: @shadow-base;
    transform: translateX(4px);
    border-color: @primary-light;
  }
}

.grid-material-card:last-child {
  margin-bottom: 0;
}

.grid-material-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.grid-material-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
}

.grid-material-label {
  color: #909399;
  font-weight: 500;
  min-width: 60px;
  flex-shrink: 0;
}

.grid-material-value {
  color: #303133;
  flex: 1;
}

.grid-material-text {
  font-size: 13px;
  color: #303133;
}

/* 网格视图详情条例展开样式 */
.grid-detail-section {
  margin-top: 12px;
  margin-bottom: 12px;
}

:deep(.grid-detail-section .el-collapse-item__header) {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
}

.grid-detail-item {
  margin-bottom: 12px;
  padding: 14px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-radius: 8px;
  border: 1px solid @border-lighter;
  box-shadow: @shadow-light;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: @shadow-base;
    transform: translateX(2px);
  }
}

.grid-detail-item:last-child {
  margin-bottom: 0;
}

.grid-detail-header {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.grid-detail-index {
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 50%;
  background-color: #409eff;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
}

.grid-detail-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.grid-detail-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
}

.grid-detail-label {
  color: #909399;
  font-weight: 500;
  min-width: 60px;
}

.grid-detail-value {
  color: #303133;
}

.grid-detail-materials {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #dcdfe6;
}

.grid-detail-material-group {
  margin-bottom: 12px;
  
  &:last-child {
    margin-bottom: 0;
  }
}

.grid-detail-material-group-title {
  font-size: 13px;
  font-weight: 600;
  color: @primary-color;
  margin-bottom: 8px;
  padding: 6px 12px;
  background: linear-gradient(135deg, rgba(64, 158, 255, 0.1) 0%, rgba(64, 158, 255, 0.05) 100%);
  border-radius: 6px;
  border-left: 3px solid @primary-color;
}

.detail-material-section {
  margin-bottom: 12px;
  
  &:last-child {
    margin-bottom: 0;
  }
}

.detail-material-title {
  font-size: 13px;
  font-weight: 600;
  color: @primary-color;
  margin-bottom: 8px;
  padding: 6px 12px;
  background: linear-gradient(135deg, rgba(64, 158, 255, 0.1) 0%, rgba(64, 158, 255, 0.05) 100%);
  border-radius: 6px;
  border-left: 3px solid @primary-color;
}

.grid-material-header {
  font-size: 14px;
  font-weight: 600;
  color: @primary-color;
  margin-bottom: 10px;
  padding: 6px 0;
  display: block;
  border-bottom: 2px solid @primary-light;
  padding-bottom: 8px;
}

.grid-detail-material-card {
  margin-bottom: 8px;
  padding: 12px 16px;
  background: linear-gradient(135deg, #ffffff 0%, #fafbfc 100%);
  border-radius: 8px;
  border: 1px solid @border-lighter;
  box-shadow: @shadow-light;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: @shadow-base;
    transform: translateX(2px);
    border-color: @success-color;
  }
}

.grid-detail-material-card:last-child {
  margin-bottom: 0;
}

.grid-material-label {
  color: #909399;
  font-weight: 500;
}

.grid-material-value {
  color: #303133;
}

/* 列表视图样式 */
.list-view-container {
  margin-top: 24px;
  background: @bg-color;
  border-radius: 12px;
  padding: 24px;
  box-shadow: @shadow-base;
}

.list-item-wrapper {
  margin-bottom: 20px;
  transition: all 0.3s ease;
}

.list-item-wrapper:last-child {
  margin-bottom: 0;
}

.list-item-card {
  border: 1px solid @border-lighter;
  border-radius: 12px;
  padding: 20px;
  background: linear-gradient(135deg, #ffffff 0%, #fafbfc 100%);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  box-shadow: @shadow-light;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    background: linear-gradient(180deg, @primary-color 0%, @primary-light 100%);
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover {
    border-color: @primary-color;
    box-shadow: @shadow-dark;
    transform: translateX(4px);

    &::before {
      opacity: 1;
    }
  }
}

.list-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #ebeef5;
}

.list-item-title {
  display: flex;
  align-items: center;
  flex: 1;
}

.list-icon {
  margin-right: 8px;
  color: #409eff;
  font-size: 18px;
}

.list-title-text {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.list-item-body {
  padding-top: 12px;
}

.list-item-row {
  display: flex;
  margin-bottom: 8px;
  font-size: 14px;
}

.list-label {
  color: #909399;
  min-width: 80px;
  margin-right: 12px;
}

.list-value {
  color: #303133;
  flex: 1;
}

.list-item-details {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #ebeef5;
}

.list-material-table-wrapper {
  width: 100%;
  
  :deep(.el-table) {
    border-radius: 6px;
    overflow: hidden;
    
    .el-table__header-wrapper {
      .el-table__header {
        th {
          background: linear-gradient(135deg, #f8f9fa 0%, #f0f2f5 100%);
          color: #606266;
          font-weight: 600;
          font-size: 13px;
          padding: 10px 4px;
          border-bottom: 2px solid #e4e7ed;
        }
      }
    }
    
    .el-table__body-wrapper {
      .el-table__body {
        tr {
          transition: all 0.3s ease;
          
          &:hover > td {
            background: linear-gradient(90deg, rgba(64, 158, 255, 0.05) 0%, rgba(64, 158, 255, 0.02) 100%) !important;
          }
          
          td {
            border-color: #ebeef5;
            font-size: 13px;
          }
        }
      }
    }
    
    &.el-table--striped {
      .el-table__body {
        tr.el-table__row--striped {
          td {
            background-color: #fafafa;
          }
        }
      }
    }
  }
  
  .list-material-plain-items {
    margin-top: 8px;
    
    .list-material-plain-text {
      padding: 6px 12px;
      background: #f5f7fa;
      border-radius: 4px;
      margin-bottom: 4px;
      font-size: 13px;
      color: #606266;
      text-align: center;
    }
  }
}

.empty-list {
  padding: 40px 0;
  text-align: center;
}

/* 材料明细样式 */
.material-detail-wrapper {
  margin-top: 0;
  text-align: left;
  width: 100%;
}

.material-detail-item {
  margin-top: 12px;
}

.material-detail-item:first-child {
  margin-top: 0;
}

.material-detail-card {
  padding: 14px 16px;
  background: linear-gradient(135deg, #ffffff 0%, #fafbfc 100%);
  border-radius: 8px;
  border: 1px solid @border-lighter;
  display: flex;

  gap: 12px;
  box-shadow: @shadow-light;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 3px;
    background: linear-gradient(180deg, @success-color 0%, #85ce61 100%);
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover {
    box-shadow: @shadow-base;
    transform: translateY(-2px);
    border-color: @success-color;

    &::before {
      opacity: 1;
    }
  }
}

.material-item-header {
  font-size: 14px;
  font-weight: 600;
  color: @primary-color;
  margin-bottom: 4px;
  padding-bottom: 8px;
  border-bottom: 2px solid @primary-light;
}

.material-detail-header {
  font-size: 13px;
  color: @text-secondary;
  font-weight: 500;
  padding: 6px 12px;
  background: @border-extra-light;
  border-radius: 6px;
  display: inline-block;
  border: 1px solid @border-lighter;
  transition: all 0.3s ease;
  
  &:hover {
    background: #f0f2f5;
    border-color: @primary-light;
  }
}

.material-field {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  white-space: nowrap;
  flex-wrap: wrap;
}

.material-label {
  color: @text-secondary;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.material-icon {
  font-size: 14px;
  color: @success-color;
  transition: all 0.3s ease;
}

.material-field:hover .material-icon {
  color: #85ce61;
  transform: scale(1.1);
}

.material-value {
  color: @text-primary;
}

.material-plain-text {
  display: inline-block;
  padding: 8px 16px;
  background-color: #ffffff;
  border-radius: 4px;
  border: 1px solid #ebeef5;
}

.material-descriptions {
  font-size: 13px;
}

.material-descriptions .el-descriptions__label {
  padding: 4px 8px;
  width: 60px;
  min-width: 60px;
  background-color: #f5f7fa;
  font-weight: 500;
  color: #606266;
  text-align: center;
  white-space: nowrap;
}

.material-descriptions .el-descriptions__content {
  padding: 4px 8px;
  min-width: 120px;
  max-width: 220px;
  color: #303133;
}

/* 合同选择相关样式 */
.tender-badge {
  margin-left: 4px;
}

.tender-select-container {
  padding: 10px 0;
}

.tender-list-container {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 10px;
  margin-bottom: 15px;
}

.tender-select-all {
  padding: 10px 0;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 10px;
}

.tender-item {
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s;
}

.tender-item:hover {
  background-color: #f5f7fa;
}

.tender-item:last-child {
  border-bottom: none;
}

.tender-action-bar {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding-top: 15px;
  border-top: 1px solid #ebeef5;
}

.tender-selected-count {
  display: flex;
  flex-wrap: wrap;

  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #606266;
}

.tender-selected-count .count-number {
  font-size: 16px;
  color: #409eff;
  font-weight: 700;
  margin: 0 4px;
}

.tender-action-buttons {
  width:500px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
  margin: 10px 0;
}

// 全局美化细节
:deep(.el-button) {
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &.el-button--primary {
    background: linear-gradient(135deg, @primary-color 0%, @primary-light 100%);
    border: none;
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);

    &:hover {
      background: linear-gradient(135deg, @primary-dark 0%, @primary-color 100%);
      box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
      transform: translateY(-2px);
    }

    &:active {
      transform: translateY(0);
    }
  }
}

:deep(.el-badge) {
  .el-badge__content {
    background: linear-gradient(135deg, @danger-color 0%, #f78989 100%);
    border: 2px solid #fff;
    box-shadow: 0 2px 8px rgba(245, 108, 108, 0.3);
    font-weight: 600;
  }
}

:deep(.el-collapse) {
  border: none;

  .el-collapse-item {
    border: none;
    margin-bottom: 8px;

    .el-collapse-item__header {
      background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
      border-radius: 8px;
      padding: 12px 16px;
      font-weight: 500;
      color: @text-primary;
      border: 1px solid @border-lighter;
      transition: all 0.3s ease;

      &:hover {
        background: linear-gradient(135deg, #ffffff 0%, #f0f2f5 100%);
        border-color: @primary-light;
        box-shadow: @shadow-light;
      }
    }

    .el-collapse-item__wrap {
      border: none;
      background: transparent;
    }

    .el-collapse-item__content {
      padding: 12px 0;
    }
  }
}

:deep(.el-dialog) {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: @shadow-dark;

  .el-dialog__header {
    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
    padding: 20px 24px;
    border-bottom: 1px solid @border-lighter;

    .el-dialog__title {
      font-weight: 600;
      color: @text-primary;
    }
  }

  .el-dialog__body {
    padding: 24px;
  }
}

:deep(.el-scrollbar) {
  .el-scrollbar__bar {
    &.is-vertical {
      .el-scrollbar__thumb {
        background: linear-gradient(180deg, @primary-color 0%, @primary-light 100%);
        border-radius: 4px;
      }
    }
  }
}

// 加载动画美化
:deep(.el-loading-mask) {
  background-color: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(4px);
}

// 空状态美化
:deep(.el-empty) {
  .el-empty__description {
    color: @text-secondary;
    font-size: 14px;
  }
}

// 响应式优化
@media (max-width: 768px) {
  .search-box {
    flex-direction: column;
    gap: 12px;

    .el-input {
      width: 100% !important;
    }

    .el-radio-group {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
  }

  .table-container {
    padding: 12px;
  }

  .grid-item {
    padding: 16px;
  }
}

// 平滑滚动
* {
  scroll-behavior: smooth;
}

// 选择文本颜色
::selection {
  background: rgba(64, 158, 255, 0.2);
  color: @text-primary;
}

// 表格标题图标样式
.table-header-with-icon {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;

  .el-icon {
    font-size: 16px;
    color: @primary-color;
    transition: all 0.3s ease;
  }

  &:hover .el-icon {
    color: @primary-light;
    transform: scale(1.1) rotate(5deg);
  }
}

// 详情条例图标动画
.detail-info-row {
  transition: all 0.3s ease;

  &:hover {
    .detail-icon {
      animation: iconPulse 0.6s ease;
    }
  }
}

@keyframes iconPulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
}

// 材料字段图标动画
.material-field {
  transition: all 0.3s ease;

  &:hover {
    .material-icon {
      animation: iconBounce 0.6s ease;
    }
  }
}

@keyframes iconBounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-3px);
  }
}
</style>
